// Copyright 2020-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  MeetingStatus,
  useNotificationDispatch,
  Severity,
  ActionType,
  useMeetingStatus,
} from "amazon-chime-sdk-component-library-react";

export const useMeetingEndRedirect = () => {
  const navigate = useNavigate();
  const dispatch = useNotificationDispatch();
  const meetingStatus = useMeetingStatus();

  useEffect(() => {
    if (meetingStatus === MeetingStatus.Ended) {
      dispatch({
        type: ActionType.ADD,
        payload: {
          severity: Severity.INFO,
          message: "The meeting was ended by another attendee",
          autoClose: true,
          replaceAll: true,
        },
      });
      navigate("/dashboard");
    }
  }, [meetingStatus]);
};

export default useMeetingEndRedirect;
